export default "__VITE_ASSET__CteRxNUD__"